/**
 * Returns `true` when a `geolocationPoint` tuple coming from the back is a
 * usable `[lng, lat]` pair. Defensive against the shapes the API has been
 * observed to return: `null`, `undefined`, `[]`, `[0, 0]`, `[null, null]`,
 * `[NaN, NaN]`, single-value arrays.
 *
 * `[0, 0]` is treated as "no geolocation" because every record in the
 * backoffice that lacks a real coordinate is initialised with that pair.
 */
export function hasValidGeolocation(geoPoint: unknown): boolean {
  if (!Array.isArray(geoPoint) || geoPoint.length < 2) return false;
  const [lng, lat] = geoPoint;
  if (typeof lng !== 'number' || typeof lat !== 'number') return false;
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return false;
  if (lng === 0 && lat === 0) return false;
  return true;
}
